"use client";

import React from "react";
import { useMultiSelectStore } from "modules/common/stores/useMultiSelectStore";
import RecentTradesContactButton, {
  type ContactUserButtonProps,
} from "modules/tradeLists/components/RecentTrades/RecentTradesContactButton";

type ContactButtonCellProps = Omit<ContactUserButtonProps, "disabled">;

export function ContactButtonCell(props: ContactButtonCellProps) {
  const isAnySelected = useMultiSelectStore((s) => s.hasSelection());
  return <RecentTradesContactButton {...props} disabled={isAnySelected} />;
}
